import React from "react";

import { Flare as CreationIcon } from "mdi-material-ui";

const Icon = () => <CreationIcon />;

const Title = () => <span>Création</span>;

const Event = { Icon, Title };

export default Event;
